module.exports = __webpack_public_path__ + "img/aviso.28430244.svg";